<template>
	<section class="select-section">
		<el-dialog :visible.sync="dialogVisible" width="70%" center>
			<p slot="title">{{title}}</p>
			<div class="search-row">

				<span style="margin-right: 10px;">课程归属：
					<!-- 1-孕妈，2-医生 -->
					<el-select class='search-select' v-model="userType"
					placeholder="请选择" size='small'>
					<el-option :value="2" label="医生课程"></el-option>
					<el-option :value="1" label="孕妈课程"></el-option>
				</el-select>
			</span>
			<!-- 课程名称 -->
			<el-input placeholder="请输入内容" v-model="searchValue"
			style='width: 300px;' size='small' clearable>
			<el-select v-model="searchKey" slot="prepend" placeholder="请选择"
			class='search-select'>
			<el-option :value="1" label="课程名称"></el-option>
			<el-option :value="2" label="讲师名称"></el-option>
		</el-select>
	</el-input>
	<el-button type="primary" size='small'
	@click='currentPage=1;getData()'>搜索</el-button>
</div>
<el-table :data="tableData" class="el-table" top='10vh' style="width: 100%" border max-height="500" @row-click='rowClickHandle'>
	<el-table-column label="选择" min-width="10%" align="center">
		<template slot-scope="scope">
			<div class="virtualBox"></div>
			<el-checkbox v-model="choiceDoctor" :label="scope.row">
				{{ }}
			</el-checkbox>
			<!-- <el-radio v-model="choiceDoctor" :label="scope.row">{{blank}}</el-radio> -->
		</template>
	</el-table-column>
	<el-table-column prop="title" label="课程名称" min-width="25%" align="center">
	</el-table-column>
	<el-table-column label="所属栏目" min-width="22%" align="center">
		<template slot-scope="scope">
			<span>
				{{scope.row.subjectNames || '-'}}</span>
			</span>
		</template>
	</el-table-column>
	<el-table-column label="所属学科" min-width="20%" align="center">
		<template slot-scope="scope">
			<span>{{scope.row.disciplineNames || '-'}}</span>
		</template>
	</el-table-column>
	<el-table-column prop="teacherNames" label="讲师" min-width="23%" align="center">
	</el-table-column>
	<el-table-column prop="offline" label="状态" min-width="23%" align="center">
		<template slot-scope="scope">
			<span v-if='scope.row.offline==1' style="color: red;">下架</span>
			<span v-else>上架</span>
		</template>
	</el-table-column>
</el-table>
<div class="pagination-wrap">
	<el-pagination class='el-pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
	</el-pagination>
</div>
<span slot="footer" class="dialog-footer">
	<el-button @click="dialogVisible = false">取 消</el-button>
	<el-button type="primary" @click="submitHandle">确 定</el-button>
</span>
</el-dialog>
</section>
</template>

<script scoped>
import selectReq from "@/api/selectSource";
export default {
	name: "selectDoctor",
	data() {
		return {
			title: "",
			blank: "",
			choiceDoctor: [],
			dialogVisible: false,
			userType: 2,
			searchKey: 1,
			searchValue: "",
			pageSize: 20,
			currentPage: 1,
			totalCount: 0,
			tableData: [],
			classTypeList: []
		};
	},
	props: {
		isSingle: {
			type: Boolean,
			default: () => true
		},
		needOn: {
			type: Boolean,
			default: () => false
		}
	},
	mounted() {
		this.getClassType()
	},
	methods: {
		open(title) {
			this.choiceDoctor = []
			this.getData();
			this.dialogVisible = true;
			this.title = title;
		},
		close() {
			console.log("close");
			this.dialogVisible = false;
		},
		submitHandle() {
			// this.$emit('select-submit', this.choiceDoctor)
			if(this.isSingle){
				this.$emit('select-submit', this.choiceDoctor[0]||{})
			}else{
				this.$emit('select-submit', this.choiceDoctor)
			}
			this.dialogVisible = false;
		},
		rowClickHandle(row) {
		// this.choiceDoctor = row;

			if(this.isSingle){
				this.choiceDoctor = [row]
			}else{
				var index = this.choiceDoctor.indexOf(row)
				if(index == -1){
					this.choiceDoctor.push(row)
				}else{
					this.choiceDoctor.splice(index,1)
				}       
			}
		},
		getData() {
			var params = {
				pageIndex: this.currentPage,
				pageSize: this.pageSize,
				searchKey: this.searchKey,
				searchValue: this.searchValue,
				userType: this.userType
			};
			if(this.needOn){
				params.offline = 0
			}
			selectReq.getCourseList(params).then(res => {
				if (res.Success) {
					this.tableData = res.Data.dataList;
					this.totalCount = res.Data.totalCount;
				} else {
					this.$message.error(res.Msg);
				}
			});
		},
		// 获取课程分类
		getClassType() {
			let data = {
				pageSize: 999,
				pageIndex: 1
			}
			selectReq.getClassTypeList(data).then(res => {
				if(res.Success){
					this.classTypeList = res.Data.dataList
				}else{
					this.$message.error(res.Msg)
				}
			})
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getData();
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getData();
		}
	}
};
</script>

<style type="text/less" lang="less" scoped>
.select-section {
	.el-dialog__wrapper {
		background-color: rgba(0, 0, 0, 0.1);
	}
	.pagination-wrap {
		margin-top: 10px;
	}
	.el-pagination {
		float: right;
	}
	.dialog-footer {
		margin-top: 40px;
	}
}
.search-row {
	margin-bottom: 10px;
	text-align: right;
	.input-with-select {
		width: 30%;
		min-width: 350px;
	}
	.search-select {
		width: 110px;
	}
}
.virtualBox{
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 9;
}
</style>
<style type="text/css">
.el-table .cell{
	position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/selectSource/selectDocOrMomCourse.vue